import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { Search } from './search'

export class SearchesRepository extends BaseRepository<Search> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.prospectApiUrl + '/' + 'searches', token, cache)
    }

    async restart(searchId: string) {
        const { json, statusCode, message } = await this.request.get(
            this.config.prospectApiUrl + '/searches/' + searchId + '/restart?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
